import React from "react";
import { Button, Card } from "react-bootstrap";

export default function SupportBrandSection({ referralLink }) {
  return (
    <Card className="mt-5 border-0 bg-white text-center">
      <Card.Body className="p-4">
        <h3 className="mb-3">Support Stocks With Nik</h3>

        <p className="mb-3">
          If you enjoy the free tools and AI portfolios on this site,
          you can support the brand by using the link below.
        </p>

          <a
            href={referralLink}
            target="_blank"
            rel="noopener noreferrer"
            className="fw-semibold mb-3"
          >
            <Button>Open a Brokerage Account (Free Stock)</Button>
          </a>

        <p className="small text-muted mb-0">
          It doesn’t cost you anything extra — and it helps keep everything free.
        </p>
      </Card.Body>
    </Card>
  );
}